// extracted by mini-css-extract-plugin
module.exports = {"balance-table":"style_balance-table__4eb_8"};